import React from 'react';
import { StyleSheet } from 'react-native';
import Text, { H1 } from '@dbk/ui-text'
import { View } from '@dbk/ui-react-utils';
import Modal from '@dbk/ui-modal';
import { ErrorIcon, WarningIcon } from '../../../components/common/icons';
import styles from './error-modal.styles';

const ErrorModal = ({ errorMsg, setErrorModal }) => {
    return (
        <Modal
            isActive={true}
            onClose={() => setErrorModal(false)}
            content={
                <View style={StyleSheet.flatten(styles.row)}>
                    <ErrorIcon width={30} height={30} />
                    <div className='margin-left-10'><Text size="large">{errorMsg}</Text></div>
                </View>
            }
        />
    );
};

export default ErrorModal;